var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "sticky-wrapper",
      staticClass: "sticky-wrapper",
      class: {
        sticked: _vm.sticked,
        unpinned: _vm.unpinned,
        pinned: !_vm.unpinned
      }
    },
    [
      _vm.height
        ? _c("div", {
            staticClass: "sticky-helper",
            style: {
              height: _vm.height + "px"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sticky-element",
          style: {
            position: _vm.position,
            top: _vm.fixedOffset + "px",
            width: _vm.width + "%",
            transition: _vm.fixedTransition
          }
        },
        [_vm._t("default", null, { scrollTop: _vm.lastScrollTop })],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }